import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import PlanInfoModal from "../modal/PlanInfoModal";
import UnitPlansInfoModal from "../modal/UnitPlansInfoModal";
import { useSelector } from "react-redux";
import GetUnitTreeApi from "../../api/units/GetUnitTreeApi";
import { useLocation } from "react-router-dom";
import { GetOrganizationLevelsApi } from "../../api/org-levels/GetOrganizationLevelsApi";
import PageLoader from "../sub/PageLoader";
import { WarningOutlined } from "@ant-design/icons";

const UnitTree = () => {
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [data, setData] = useState([]);
  const [levels, setLevels] = useState();
  const [unitId, setUnitId] = useState("");
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const proHeight = document.body.clientHeight;
  let curLocation = useLocation();

  useEffect(() => {
    getTreeData();
    getOrganizationLevels();
  }, []);

  async function getTreeData() {
    let path = curLocation.pathname;
    let id = path.split("/units/");
    const apiResponse = await GetUnitTreeApi(id[1], perfCycleState.id);
    if (apiResponse.message === "success") {
      setData(apiResponse.units);
      if (apiResponse.units?.children?.length) {
        setCanShow(true);
      }
    }
    setCanStart(true);
  }

  async function getOrganizationLevels() {
    const apiResponse = await GetOrganizationLevelsApi();
    if (apiResponse.message === "success") {
      setLevels(apiResponse.levels);
    }
  }

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    levels?.forEach((level) => {
      if (level.name === node.level) {
        nodeColor = level.color;
      }
    });
    return nodeColor;
  }

  const config = {
    data,
    nodeCfg: {
      autoWidth: true,
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
      size: [180, 50],
    },
    edgeCfg: {
      type: "polyline",
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
    autoFit: false,
  };

  function showEmptyUnits() {
    return (
      <div
        style={{ height: proHeight - 188 }}
        className="flex justify-center items-center w-full h-full"
      >
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No children available
          </div>
          <div className="mb-3 text-gray-400">This unit have no children</div>
        </div>
      </div>
    );
  }

  return canStart ? (
    canShow ? (
      <>
        <div className="border">
          <DecompositionTreeGraph
            {...config}
            onReady={(graph) => {
              graph.on("node:click", (evt) => {
                setInfoModal(true);
                setUnitId(evt.item._cfg.id);
              });
            }}
          />
        </div>
        <UnitPlansInfoModal
          visible={infoModal}
          handleCancel={() => setInfoModal(false)}
          unitId={unitId}
        />
      </>
    ) : (
      showEmptyUnits()
    )
  ) : (
    <PageLoader />
  );
};

export default UnitTree;
